import React, { useCallback, useEffect, useRef, useState } from 'react'
import ReactTags, { Tag} from 'react-tag-autocomplete'
import {
    ADD_TAG_TO_ASSESSMENT, ADD_TAG_TO_ASSESSMENT_INVITE,
    REMOVE_TAG_FROM_ASSESSMENT, REMOVE_TAG_FROM_ASSESSMENT_INVITE,
    TAG_SUGGESTIONS
} from '../../../apollo/queries';
import { useMutation } from '@apollo/client';
import { client } from '../../../apollo/client';
import styles from "./TagInput.module.scss";
import classNames from 'classnames';
import { renderHook } from '@testing-library/react';


interface TagInputData {
    type: 'ASSESSMENT' | 'ASSESSMENT_INVITE'
    entityId: number
    row:  {
        tags: Tag[] | []
    }

    suggestions: Tag[] | []
    setCurrentActiveRowIndex: Function
    currentActiveRowIndex: number
    rowIndex: number
}

export const TagInput = ({
  type,
 entityId,
 row,
  suggestions,
  setCurrentActiveRowIndex,
  currentActiveRowIndex,
  rowIndex
}: TagInputData) => {
    const [isEditable, setIsEditable] = useState(false)

    const [addTagToAssessmentAction] = useMutation(ADD_TAG_TO_ASSESSMENT, {
        onCompleted: (data) => {
            // console.log(data)
            const index = row.tags.findIndex((obj => obj.name == data.addTagToAssessment.name));
            row.tags[index].id = data.addTagToAssessment.id
        }
    });
    const [removeTagFromAssessmentAction] = useMutation(REMOVE_TAG_FROM_ASSESSMENT, {
        onCompleted: (data) => {
            // console.log(data)
        }
    });

    const [addTagToInviteAction] = useMutation(ADD_TAG_TO_ASSESSMENT_INVITE, {
        onCompleted: (data) => {
            // console.log(data)
            const index = row.tags.findIndex((obj => obj.name == data.addTagToAssessmentInvite.name));
            row.tags[index].id = data.addTagToAssessmentInvite.id
        }
    });
    const [removeTagFromInviteAction] = useMutation(REMOVE_TAG_FROM_ASSESSMENT_INVITE, {
        onCompleted: (data) => {
            // console.log(data)
        }
    });

    const addTag = (name: string) => {
        if(type === 'ASSESSMENT') {
            addTagToAssessmentAction({
                variables: {
                    input: {
                        name,
                        assessmentId: entityId
                    },
                },
            }).then(() => {
                client.refetchQueries({
                    include: [TAG_SUGGESTIONS]
                })
            });
        } else {
            addTagToInviteAction({
                variables: {
                    input: {
                        name,
                        assessmentInviteId: entityId
                    },
                },
            }).then(() => {
                client.refetchQueries({
                    include: [TAG_SUGGESTIONS]
                })
            });
        }
    };

    const removeTag = (tagId: number | string) => {
        if(type === 'ASSESSMENT') {
            removeTagFromAssessmentAction({
                variables: {
                    input: {
                        tagId,
                        assessmentId: entityId
                    },
                },
            });
        } else {
            removeTagFromInviteAction({
                variables: {
                    input: {
                        tagId,
                        assessmentInviteId: entityId
                    },
                },
            });
        }
    };

    const wrapper = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if(currentActiveRowIndex === rowIndex) {
            setIsEditable(true)
        } else {
            setIsEditable(false)
        }
    }, [currentActiveRowIndex]);

    useEffect(() => {
        if(isEditable) {
            wrapper.current?.getElementsByTagName('input')[0].focus()
        }
    }, [isEditable])

    const onDelete = useCallback((tagIndex: number | string) => {
        // @ts-ignore
        removeTag(row.tags[tagIndex].id)
        row.tags = row.tags.filter((_, i) => i !== tagIndex)
    }, [row.tags])

    const onAddition = useCallback((newTag: Tag) => {
        row.tags = [...row.tags, newTag]
        addTag(newTag.name)
    }, [row.tags])

    return (
        <div ref={wrapper}
             key={`tagInput-${entityId}`}
            className={classNames(styles.wrapper, { [styles.notActive]: !isEditable}) }
            onClick={() => {
                setCurrentActiveRowIndex(rowIndex)
            }}
            title={!isEditable ? 'Change labels' : ''}
        >
            {!isEditable && row.tags.length > 0 && (
                row.tags.map(tag => {
                    return <span key={`tagInputSpan-${entityId}-${tag.id}`} className={styles.tag}>{tag.name}</span>
                })
            )}
            {!isEditable && row.tags.length === 0 && (
                <span key={`tagInputSpan-${entityId}`} className={styles.noTags}>Click to add a label...</span>
            )}

            {/*TODO for the 'labelTable' we want to add text to the input field to make it obvious that people can give multiple labels */}
            {!isEditable && row.tags.length !== 0 && (
                <span key={`tagInputSpan-${entityId}`} className={styles.noTags}>Click to add more labels...</span>
            )}
            {isEditable  &&
                <ReactTags
                    key={`tagInputTags-${entityId}`}
                    allowNew={true}
                    tags={row.tags}
                    suggestions={suggestions}
                    // noSuggestionsText='No matching countries'
                    onDelete={onDelete}
                    // addOnBlur={true}
                    onAddition={onAddition}
                    // @ts-ignore
                    classNames={{
                        root: 'react-tags',
                        rootFocused: 'is-focused',
                        selected: 'react-tags__selected',
                        selectedTag: classNames('react-tags__selected-tag', styles.tagWrapper),
                        selectedTagName: 'react-tags__selected-tag-name',
                        search: 'react-tags__search',
                        // searchWrapper: 'react-tags__search-wrapper',
                        searchInput: 'react-tags__search-input',
                        suggestions: 'react-tags__suggestions',
                        suggestionActive: 'is-active',
                        suggestionDisabled: 'is-disabled',
                        // suggestionPrefix: 'react-tags__suggestion-prefix'
                    }}
                />
            }
        </div>
    )
}
